import * as Sentry from '@sentry/nextjs';
import JWT from 'jsonwebtoken';

import { getEnvOrThrow } from 'utils/getEnv';

const generateKustomerLivechatToken = (email: string) => {
  try {
    // @ts-expect-error - this env is currently defined nowwhere on local envs
    const key = getEnvOrThrow('REACT_APP_KUSTOMER_LIVECHAT_SECRET_KEY') as string;

    return JWT.sign(
      {
        email,
        iat: Math.floor(Date.now() / 1000),
      },
      key,
      {
        header: {
          alg: 'HS256',
          typ: 'JWT',
        },
      },
    );
  } catch (error) {
    Sentry.withScope((scope) => {
      scope.setLevel('error');
      Sentry.captureMessage(`[Kustomer Livechat JWT] ${error}`);
    });
    return null;
  }
};

export default generateKustomerLivechatToken;
